import { useState, useEffect } from 'react';
import { useAuth, API } from '../App';
import axios from 'axios';
import Layout from '../components/Layout';
import { Card } from '@/components/ui/card';
import { HelpCircle, ChevronDown, ChevronUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function FAQ() {
  const { t } = useTranslation();
  const [faqItems, setFaqItems] = useState([]);
  const [openItems, setOpenItems] = useState({});

  useEffect(() => {
    fetchFAQ();
  }, []);

  const fetchFAQ = async () => {
    try {
      const response = await axios.get(`${API}/faq`);
      setFaqItems(response.data);
    } catch (error) {
      console.error('Error fetching FAQ:', error);
    }
  };

  const toggleItem = (id) => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <HelpCircle className="h-8 w-8 text-teal-500" />
          <h1 className="text-3xl font-bold text-gray-900">{t('faq.title')}</h1>
        </div>

        <p className="text-gray-600">{t('faq.subtitle')}</p>

        <div className="space-y-4">
          {faqItems.map((item) => (
            <Card key={item.id} className="overflow-hidden">
              <button
                onClick={() => toggleItem(item.id)}
                className="w-full p-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
              >
                <h3 className="font-semibold text-gray-900 flex-1 pr-4">{item.question}</h3>
                {openItems[item.id] ? (
                  <ChevronUp className="h-5 w-5 text-teal-500 flex-shrink-0" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-gray-400 flex-shrink-0" />
                )}
              </button>
              
              {openItems[item.id] && (
                <div className="px-6 pb-6 pt-0">
                  <p className="text-gray-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </Card>
          ))}
        </div>

        <Card className="p-6 bg-teal-50 border-teal-200">
          <h3 className="font-bold text-gray-900 mb-2">{t('faq.stillQuestions')}</h3>
          <p className="text-gray-600">
            {t('faq.contactUs')} <a href="mailto:chronos.support@protonmail.com" className="text-teal-600 hover:text-teal-700 dark:text-teal-400 dark:hover:text-teal-300 font-medium">chronos.support@protonmail.com</a>
          </p>
        </Card>
      </div>
    </Layout>
  );
}
